<template>
    <b-form>
        <b-form-group v-if="inputLimits">
            <template slot="label">
                <b-row>
                    <b-col cols="9">{{$t('feed.newMessage.message')}}: *</b-col>
                    <b-col cols="3" class="text-right">
                        <small>
                            <b-badge>{{newMessage.content.length}} / {{inputLimits.feedItem}}</b-badge>
                        </small>
                    </b-col>
                </b-row>
            </template>
            <b-form-textarea 
                name="messageText"
                v-validate="'required'"
                ref="newMessageBox"
                v-model="newMessage.content"
                v-on:paste="paste($event)"
                :rows="3" :max-rows="3"
                :no-resize="true"
                :maxlength="inputLimits.feedItem"
                :state="!veeErrors.has('messageText')">     
            </b-form-textarea>
            <span v-show="veeErrors.has('messageText')" style="color: red;" class="small">{{ $t('feed.messages.validation.messageContent') }}</span>
        </b-form-group>
        <b-row>
            <b-col class="text-right">
                <b-button v-if="!hideButton" class="mr-2"
                          :size="'sm'"
                          @click="discardMessage">{{ $t('feed.newMessage.discard') }}
                </b-button>
                <b-button v-if="!hideButton"
                          class="btn-primary"
                          :size="'sm'"
                          @click="createNewMessage">{{ $t('feed.newMessage.create') }}
                </b-button>
            </b-col>
        </b-row>
    </b-form>
</template>

<script>
import toastr from 'toastr';
import {mapState} from 'vuex';
import i18n from '@/i18n.bootstrap';

export default {
    props: {
        file: {
            default: null,
            type: Object
        },
        hideButton: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            newMessage: {
                content: ''
            }
        }
    },
    computed: {
        ...mapState('system', ['inputLimits']),
        projectPermissions() {
          if(this.$store.state.projects.currentProject.projectData.role){
            return this.$store.state.projects.currentProject.projectData.role.permissions;
          } else {
            return [];
          }
        },
    },

    methods: {
        createNewMessage() {
            let that = this;
            this.$validator.validateAll()
                .then(result => {
                    if(result) {
                        let newMessage = {
                            projectId: this.$route.params.projectId,
                            item: {
                                content: this.newMessage.content,
                                relatedDocuments: []
                            }
                        }

                        if(this.file !== null) {
                            newMessage.item.relatedDocuments.push(this.file.id);
                        }

                        this.$store.dispatch('projects/addFeedItem', newMessage)
                            .then(() => { 
                                that.clearMessageForm();
                                toastr.success(i18n.t('feed.messages.action.success'));
                                // Success event to close wrapper component
                                this.$emit('closeMessageForm');
                            })
                            .catch(() => toastr.error(i18n.t('feed.messages.action.error')));
                    }
                })
        },

        updateMessage() {
            this.$validator.validateAll()
                .then(result => {
                    if(result) {
                        let message = {
                            projectId: this.$route.params.projectId,
                            item: {
                                id: this.newMessage.id,
                                content: this.newMessage.content
                            }
                        }

                        this.$store.dispatch('projects/updateFeedItem', message)
                            .then(() => { 
                                toastr.success(i18n.t('feed.messages.action.successUpdate'));
                                // Success event to close wrapper component
                                this.$emit('closeMessageForm');
                            })
                            .catch(() => toastr.error(i18n.t('feed.messages.action.errorUpdate')));
                    }
                })
        },

        discardMessage() {
            this.clearMessageForm();
            this.$emit('closeMessageForm');
        },

        paste(e) {
            e.preventDefault();
            var text = e.clipboardData.getData("text/plain");
            document.execCommand("insertHTML", false, text);
        },

        clearMessageForm() {
            this.newMessage.content = '';
        }
    }
}
</script>
